<div class="p-fluid">
  <h3>Website</h3>
  <div class="p-field">
    <label for="website-url" class="p-text-bold required">Website URL</label>
    <input id="website-url" type="text" 
                            pInputText
                            autocorrect="off" 
                            spellcheck="false"
                            autocomplete="off" 
                            placeholder="Paste the website URL here"
                            [ngModel]="feature.value" 
                            (ngModelChange)="onInputChange($event)"> 
  </div>
</div>